export const BuildInfo = {timestamp:1782174765000}
